import {createContext} from 'react';

type HomepageCellcomTvContextType = {
  setVisible: (visible: boolean) => void;
  visible: boolean;
  transparent: boolean;
};
export const HomepageCellcomTvContext = createContext<HomepageCellcomTvContextType>(null);
